module.exports = __webpack_public_path__ + "media/images/arrow-faea6d3046c6a2d44ce94c26e3776384.png";